module.exports = __webpack_public_path__ + "static/media/0023.311cb23e.jpg";